/*
 * lc-pdp-sticky-atc.js
 * Mobile sticky Add-to-Cart bar for the product page.
 * - Shows a fixed bottom bar once the main ATC button scrolls out of view.
 * - Mirrors the LIVE, variant-aware price from the main price block.
 * - Tapping it submits the real product form, so the SELECTED variant is added.
 *
 * Overlap handling: we do NOT move Klaviyo's teaser (fighting its own script
 * causes jank on scroll). Instead, while the ATC bar is showing we add
 * `body.lc-atc-active`, and CSS hides the bottom-docked Klaviyo teaser + the
 * Personalize pill. Up top (no ATC bar) the teaser shows normally.
 */
(function () {
  function init() {
    var bar = document.querySelector('[data-lc-sticky-atc]');
    if (!bar) return;

    var mainAtc = document.querySelector('.product-form__submit');
    if (!mainAtc) return;

    var proxyBtn = bar.querySelector('[data-lc-sticky-add]');
    var stickyPriceEl = bar.querySelector('.lc-sticky-atc__price');
    var mainPriceEl = document.querySelector('[id^="price-"]');

    // ---- Mirror the live, variant-aware price into the sticky bar ----
    function syncPrice() {
      if (!stickyPriceEl || !mainPriceEl) return;
      var saleEl = mainPriceEl.querySelector('.price-item--sale:not(.hidden)');
      var regEl = mainPriceEl.querySelector('.price-item--regular');
      var src = saleEl || regEl || mainPriceEl;
      var txt = (src.textContent || '').replace(/\s+/g, ' ').trim();
      if (txt) stickyPriceEl.textContent = txt;
    }

    // ---- Reflect availability/label of the main button ----
    function syncButton() {
      if (!proxyBtn) return;
      proxyBtn.disabled = mainAtc.hasAttribute('disabled');
      var mainText = (mainAtc.querySelector('span') || mainAtc).textContent.replace(/\s+/g, ' ').trim();
      if (mainText) proxyBtn.textContent = mainText;
    }

    syncPrice();
    syncButton();

    if ('MutationObserver' in window) {
      if (mainPriceEl) {
        new MutationObserver(syncPrice).observe(mainPriceEl, { childList: true, subtree: true, characterData: true });
      }
      new MutationObserver(syncButton).observe(mainAtc, { attributes: true, childList: true, subtree: true });
    }

    // ---- Show the bar once the main ATC scrolls above the viewport ----
    function setVisible(show) {
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      document.body.classList.toggle('lc-atc-active', show);
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        var entry = entries[0];
        var scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        setVisible(scrolledPast);
      }, { threshold: 0 });
      observer.observe(mainAtc);
    } else {
      setVisible(true);
    }

    // ---- Tap submits the real product form (selected variant) ----
    if (proxyBtn) {
      proxyBtn.addEventListener('click', function () {
        if (mainAtc.hasAttribute('disabled')) return;
        mainAtc.click();
      });
    }

    // ---- Promo strip welded to the bar: opens the Klaviyo signup form ----
    // Surfaces Klaviyo's "10% off" offer as a gold strip on top of the ATC bar
    // (one element with it). On tap we call klaviyo.openForm(formId) directly —
    // the only reliable way to open the form (synthetic teaser clicks don't work).
    // formId comes from the live teaser's class (kl-teaser-XXXXXX); if the teaser
    // isn't in the DOM we fall back to the known form id.
    var promoBtn = bar.querySelector('[data-lc-sticky-promo]');
    if (promoBtn) {
      var FALLBACK_FORM_ID = 'T5Aw9b';
      function getFormId() {
        var teaser = document.querySelector('[class*="kl-teaser-"]');
        if (teaser) {
          var m = (teaser.className || '').toString().match(/kl-teaser-([A-Za-z0-9]+)/);
          if (m) return m[1];
        }
        return FALLBACK_FORM_ID;
      }
      // The strip is shown whenever the bar is shown (offer is always available).
      promoBtn.removeAttribute('hidden');
      promoBtn.addEventListener('click', function () {
        if (window.klaviyo && typeof window.klaviyo.openForm === 'function') {
          try { window.klaviyo.openForm(getFormId()); } catch (e) {}
        }
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
